import React, { useState } from 'react';

const CORRECT_PASSWORD = 'geoai4asa2026';
const STORAGE_KEY = 'workshop_auth';

export default function PasswordGate({ children }: { children: React.ReactNode }) {
    const [authenticated, setAuthenticated] = useState(
        () => localStorage.getItem(STORAGE_KEY) === 'true'
    );
    const [input, setInput] = useState('');
    const [error, setError] = useState(false);

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        if (input === CORRECT_PASSWORD) {
            localStorage.setItem(STORAGE_KEY, 'true');
            setAuthenticated(true);
        } else {
            setError(true);
            setInput('');
        }
    };

    if (authenticated) return <>{children}</>;

    return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-white select-none">
            <h1 className="text-3xl font-bold mb-2">Workshop on GeoAI for Autonomous Spatial Analysis</h1>
            <p className="text-gray-500 mb-8">This site is password protected.</p>
            <form onSubmit={handleSubmit} className="flex flex-col items-center gap-3 w-full max-w-sm">
                <input
                    type="password"
                    value={input}
                    onChange={e => { setInput(e.target.value); setError(false); }}
                    placeholder="Enter password"
                    autoFocus
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-green-500"
                />
                {error && <p className="text-red-500 text-sm">Incorrect password. Please try again.</p>}
                <button
                    type="submit"
                    className="w-full px-6 py-2 rounded-3xl bg-[#039876] text-white hover:bg-[#038264]"
                >
                    Enter
                </button>
            </form>
        </div>
    );
}
